import { ConfirmActionDialog, ConfirmActionDialogRef } from "@/components/ConfirmActionDialog";
import { Button } from "@/components/ui/button";
import { showSuccess, showApiError } from "@/lib/toast";
import { HospitalityMenu } from "@/lib/types";
import { syncHospitalityMenu } from "@/sideEffects/api";
import { useQueryClient, useMutation } from "@tanstack/react-query";
import { RefreshCcwIcon } from "lucide-react";
import React, { useRef } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  hospitalityMenu: HospitalityMenu;
}

export const SyncHospitalityMenuButton: React.FC<Props> = ({ hospitalityMenu }) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const dialogRef = useRef<ConfirmActionDialogRef>(null);

  const syncHospitalityMenuMutation = useMutation({
    mutationFn: (id: number) => syncHospitalityMenu(id),
    onSuccess: () => {
      showSuccess(t("hospitalityMenu.syncedSuccess"));
      queryClient.invalidateQueries({
        queryKey: ["getHospitalityMenu", hospitalityMenu.id],
      });
      dialogRef.current?.close();
    },
    onError: showApiError,
  });

  return (
    <ConfirmActionDialog
      ref={dialogRef}
      title={t("hospitalityMenu.syncServer")}
      description={t("hospitalityMenu.syncConfirm")}
      confirmButtonText={t("hospitalityMenu.syncServer")}
      trigger={
        <Button variant="outline" className="bg-green-500 hover:bg-green-600" size="sm">
          {t("hospitalityMenu.syncServer")} <RefreshCcwIcon className="w-4 h-4" />
        </Button>
      }
      onConfirm={() => syncHospitalityMenuMutation.mutate(hospitalityMenu.id)}
      isLoading={syncHospitalityMenuMutation.isPending}
    />
  );
};
